module.exports = __webpack_public_path__ + "img/reward_content_title_2.3c03cf50.png";